:host {
  display: block;
  min-width: 320px;
}

rt-graph + rt-table {
  margin-top: 20px;
}
